module.exports = {
  LANDING: '/',
  SIGN_UP: '/signup',
  SIGN_IN: '/signin',
  HOME: '/home',
  ACCOUNT: '/account',
  PASSWORD_FORGET: '/pw-forget',
  DEMO: '/demo'
};
